// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3JtP0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3jRO5"};